import React, { useContext, useState } from 'react';
import AnnonceContext from '../../../../../contexts/AnnonceContext';

export default function Switch({ name, isSecret = false }) {
  const { setFormAttributes } = useContext(AnnonceContext);
  const [value, setValue] = useState(false);

  const handleCheck = () => {
    setFormAttributes((formAttributes) => [
      ...formAttributes.filter((att) => att.attribute !== name),
      {
        attribute: name,
        attributeValue: !value === true ? 'Oui' : 'Non',
        isSecret: isSecret,
      },
    ]);
    setValue(!value);
  };

  return (
    <label className="inline-flex items-center cursor-pointer">
      <div className="relative">
        <input
          type="checkbox"
          className="sr-only"
          checked={value}
          onChange={handleCheck}
        />
        <div className={`block w-14 h-8 rounded-full transition-colors duration-200 ease-in-out ${
          value ? 'bg-[#1b9faa]' : 'bg-gray-300'
        }`}>
          <div className={`absolute left-1 top-1 bg-white w-6 h-6 rounded-full transition-transform duration-200 ease-in-out ${
            value ? 'transform translate-x-6' : ''
          }`} />
        </div>
      </div>
      <span className="ml-3 text-gray-700">{name}</span>
    </label>
  );
}
